var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M4.5 9V3H1.5V10.5C1.5 12.9853 3.51472 15 6 15V24H9V15C11.4853 15 13.5 12.9853 13.5 10.5V3H10.5V9H9V3H6V9H4.5Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M21 24V3H18L15.1518 12.9684C15.0512 13.3211 15 13.6861 15 14.0528C15 15.9063 16.2775 17.4614 18 17.8856V24H21Z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }